import { faExclamationCircle } from "@fortawesome/pro-duotone-svg-icons";
import { Button, Container, createStyles, Group, Input, Text, TextInput } from "@mantine/core";
import React, { useState } from "react";
import { Icon } from "../../../custom-components/icons";
import Modal from "../../../custom-components/model";
import { User } from "../../../models/models";
import t from "../../../stores/language";
const useStyles = createStyles((theme) => ({
  deleteIconDiv: {
    fontSize: theme.fontSizes.md,
    flexWrap: "nowrap",
    marginBottom: theme.other.arc.margins[2],
  },

  deleteTextInputError: {
    fontSize: theme.fontSizes.sm,
  },
  deleteText: {
    textOverflow: "ellipsis",
    display: "block",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  modalFooter: {
    borderTop: "1px solid #ccc",
    padding: theme.other.arc.paddings[2],
    justifyContent: "end",
  },
}));
export const DeleteConfirmModal = function DeleteConfirmModal({
  item,
  onOk,
  onCancel,
  confirmText,
  visible,
}: {
  item: User | null;
  onOk: () => void;
  onCancel: () => void;
  confirmText?: string;
  visible: boolean;
}) {
  const [deleteText, setDeleteText] = useState<string | null>(null);
  const [saving, setSaving] = useState<boolean>(false);
  const { classes } = useStyles();

  const deleteCancel = () => {
    setDeleteText(null);
    setSaving(false);
    visible = false;
    onCancel();
  };
  const deleteConfirm = () => {
    setSaving(true);
    if (deleteText?.toLowerCase() != "delete") {
      setDeleteText("");
      setSaving(false);
      return;
    }
    setDeleteText(null);
    setSaving(false);
    visible = false;
    onOk();
  };

  return (
    <Modal
      opened={visible}
      header={t("Are You Sure ?")}
      footer={
        <Group className={classes.modalFooter}>
          <Button variant="default" onClick={deleteCancel}>
            {t("No")}
          </Button>
          <Button color="red" onClick={deleteConfirm} loading={saving}>
            {t("Yes")}
          </Button>
        </Group>
      }
      withCloseButton={true}
      onClose={deleteCancel}
      size={500}
    >
      <Container p={"xs"}>
        <Group className={classes.deleteIconDiv}>
          <Icon size="lg" color="#faad14" icon={faExclamationCircle} />
          <Text lineClamp={2} className={classes.deleteText}>
            {confirmText ? confirmText + ". " : ""}
            {t(`Are you sure you want to delete, ${item?.name ?? ""}`)}
          </Text>
        </Group>
        <Input.Wrapper
          classNames={{ error: classes.deleteTextInputError }}
          error={deleteText == "" ? <Text>{t("Please type `delete` to confirm")}</Text> : null}
        >
          <TextInput
            placeholder={t("Please type `delete` to confirm")}
            onChange={(e) => {
              setDeleteText(e.target.value);
            }}
          />
        </Input.Wrapper>
      </Container>
    </Modal>
  );
};
